import { CEL_ICON_COLORS, CEL_ICON_NAMES, CEL_ICON_SIZES } from '../../models/common.model';
import * as i0 from "@angular/core";
export class InfoPopoverComponent {
    constructor() {
        this.message = '';
        this.iconColor = CEL_ICON_COLORS.WHITE;
        this.iconName = CEL_ICON_NAMES.INFORMATION;
        this.iconSize = CEL_ICON_SIZES.MEDIUM;
        this.openPopover = false;
    }
    togglePopover() {
        this.openPopover = !this.openPopover;
    }
    get CelIconSizes() {
        return CEL_ICON_SIZES;
    }
}
InfoPopoverComponent.ɵfac = function InfoPopoverComponent_Factory(t) { return new (t || InfoPopoverComponent)(); };
InfoPopoverComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: InfoPopoverComponent, selectors: [["realize-reports-overview-info-popover"]], inputs: { message: "message", iconColor: "iconColor", iconName: "iconName", iconSize: "iconSize" }, decls: 5, vars: 5, consts: [[1, "info-popover-wrapper"], ["data-toggle", "true", "data-identifier", "info-btn", "data-toggle", "true", "data-has-popover", "true", "data-open-popover", "false", 1, "info-popover-icon"], ["clas", "info-popover-content"]], template: function InfoPopoverComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "realize-reports-overview-cel-icon-button", 1)(2, "div")(3, "p", 2);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵattribute("data-name", ctx.iconName)("data-size", ctx.iconSize)("data-color", ctx.iconColor)("data-aria-label", ctx.iconName);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.message);
    } }, styles: [".info-popover-icon[_ngcontent-%COMP%] {\n  --icon-button-popover-right: 0;\n  --icon-button-popover-wrapper-right: 0;\n  --icon-button-popover-border-radius: 5px;\n  --icon-button-popover-max-width: 300px;\n  --icon-button-hover-bg-color: transparent;\n}\n.info-popover-content[_ngcontent-%COMP%] {\n  margin: 0px;\n}"] });
